export default "__VITE_ASSET__DQbMhAR2__"